export async function createPlayerDetailModalStrings (modelingPlayerDetailData) {
  console.log('createPlayerDetailModalStrings');
  const tmpPlayerDetailModal = await fetch('/assets/template/modalPlayerDetail.html')
    .then(res => res.text())
    .then(res => res.trim().replace(/\n\s*/g, ''));

  const playerDetailModalStrings = modelingPlayerDetailData.map(playerDetail => {
    return tmpPlayerDetailModal.replace(/{{ id }}/g, playerDetail.id)
  })

  // console.log('cardModalStrings', cardModalStrings.join(''));
  return playerDetailModalStrings.join('');
}

